import LoadFavorite from '../components/LoadFavorite';
// import SetBookmark from '../components/SetBookmark';

const Mypage = () => {
  return (
    <section>
      <LoadFavorite />
      {/* <SetBookmark /> */}
    </section>
  );
};

export default Mypage;
